import script from "./AppCardInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppCardInfo.vue?vue&type=script&setup=true&lang=ts"

import "./AppCardInfo.vue?vue&type=style&index=0&id=28fe9e52&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28fe9e52"]])

export default __exports__